// extracted by mini-css-extract-plugin
export default {"cateogry":"_4f36b832","isExpanded":"_1d1672bf","cateogryLabel":"_d79c9f34","cateogryIcon":"_82df3cd9","topic":"_87acd8e3","expandingAreaClass":"_777f2edd"};